import { render, staticRenderFns } from "./WHGender.vue?vue&type=template&id=a563d10a&"
import script from "./WHGender.vue?vue&type=script&lang=js&"
export * from "./WHGender.vue?vue&type=script&lang=js&"
import style0 from "./WHGender.vue?vue&type=style&index=0&id=a563d10a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports